export const UI_SET_LOCALE = 'UI_SET_LOCALE';
export const UI_INFO_MSG = 'UI_INFO_MSG';
export const UI_ERROR_MSG = 'UI_ERROR_MSG';
export const UI_START_LOADING = 'UI_START_LOADING';
export const UI_STOP_LOADING = 'UI_STOP_LOADING';
export const UI_START_LOADING_TX = 'UI_START_LOADING_TX';
export const UI_STOP_LOADING_TX = 'UI_STOP_LOADING_TX';
export const UI_START_BLOCKING_LOADING = 'UI_START_BLOCKING_LOADING';
export const UI_STOP_BLOCKING_LOADING = 'UI_STOP_BLOCKING_LOADING';
export const UI_STOP_ALL_LOADING = 'UI_STOP_ALL_LOADING';
export const UI_CLOSE_TX_DIALOG = 'UI_CLOSE_TX_DIALOG';
export const UI_LOGIN_OVERRIDE = 'UI_LOGIN_OVERRIDE';
export const UI_DISABLE_ERROR = 'UI_DISABLE_ERROR';
export const UI_HEADER_UPDATE = 'UI_HEADER_UPDATE';
export const UI_POPUP_ERR = 'UI_POPUP_ERR';
export const UI_POPUP_INFO = 'UI_POPUP_INFO';
export const UI_SET_SIGN_FINISH = 'UI_SET_SIGN_FINISH';
export const UI_SET_TX_FAILED = 'UI_SET_TX_FAILED';
export const UI_SET_HIDE_TX_DIALOG_ACTION = 'UI_SET_HIDE_TX_DIALOG_ACTION';
export const UI_SET_TX_DIALOG_ACTION = 'UI_SET_TX_DIALOG_ACTION';
export const UI_OPEN_SLIDING_MENU = 'UI_OPEN_SLIDING_MENU';
export const UI_CLOSE_SLIDING_MENU = 'UI_CLOSE_SLIDING_MENU';
export const UI_SET_PROMPT_NOTIFICATION_DIALOG = 'UI_SET_PROMPT_NOTIFICATIONEMAIL_DIALOG';
export const UI_SET_AUTH_DIALOG = 'UI_SET_AUTH_DIALOG';
export const UI_SET_RE_AUTH_DIALOG = 'UI_SET_RE_AUTH_DIALOG';
export const UI_SET_WALLET_NOTICE_DIALOG = 'UI_SET_WALLET_NOTICE_DIALOG';
export const UI_POPUP_OPEN = 'UI_POPUP_OPEN';
export const UI_POPUP_CLOSE = 'UI_POPUP_CLOSE';
export const USER_SET_USER_INFO = 'USER_SET_USER_INFO';
export const USER_SET_LOCAL_WALLET = 'USER_SET_LOCAL_WALLET';
export const USER_SET_FETCHING = 'USER_SET_FETCHING';
export const USER_SET_AFTER_AUTH_ROUTE = 'USER_SET_AFTER_AUTH_ROUTE';
export const USER_SET_LIKECOIN_AMOUNT_OBJECT = 'USER_SET_LIKECOIN_AMOUNT_OBJECT';
export const USER_SET_AUTH_CORE_ACCESS_TOKEN = 'USER_SET_AUTH_CORE_ACCESS_TOKEN';
export const USER_UPDATE_READ_CONTENT_STATUS = 'USER_UPDATE_READ_CONTENT_STATUS';
export const USER_SET_WALLET_CONNECT_URI = 'USER_SET_WALLET_CONNECT_URI';
export const USER_SET_WALLET_CONNECT_CONNECTING = 'USER_SET_WALLET_CONNECT_CONNECTING';
export const PAYMENT_SET_PENDING_HASH = 'PAYMENT_SET_PENDING_HASH';
export const PAYMENT_SET_PENDING_TX_INFO = 'PAYMENT_SET_PENDING_TX_INFO';
export const PAYMENT_SET_COSMOS_WALLET_SOURCE = 'PAYMENT_SET_COSMOS_WALLET_SOURCE';
export const STATIC_DATA_SET_LIKECOIN_USD_NUMERIC_PRICE = 'STATIC_DATA_SET_LIKECOIN_USD_NUMERIC_PRICE';
export const STATIC_DATA_SET_LIKE_STAT = 'STATIC_DATA_SET_LIKE_STAT';
export const STATIC_DATA_SET_LIKE_SUGGEST_LIST = 'STATIC_DATA_SET_LIKE_SUGGEST_LIST';
export const STATIC_DATA_SET_LIKE_SUGGEST_DETAIL = 'STATIC_DATA_SET_LIKE_SUGGEST_DETAIL';
export const STATIC_DATA_SET_USER_MIN_INFO = 'STATIC_DATA_SET_USER_MIN_INFO';
export const STATIC_DATA_SET_LIKER_LIST_DETAIL = 'STATIC_DATA_SET_LIKER_LIST_DETAIL';
export const AUTHCORE_SET_ACCESS_TOKEN = 'AUTHCORE_SET_ACCESS_TOKEN';
export const AUTHCORE_SET_AUTH_CLIENT = 'AUTHCORE_SET_AUTH_CLIENT';
export const AUTHCORE_SET_KV_CLIENT = 'AUTHCORE_SET_KV_CLIENT';
export const AUTHCORE_SET_COSMOS_PROVIDER = 'AUTHCORE_SET_COSMOS_PROVIDER';
export const AUTHCORE_SET_OAUTH_FACTORS = 'AUTHCORE_SET_OAUTH_FACTORS';
export const AUTHCORE_SET_CURRENT_USER = 'AUTHCORE_SET_CURRENT_USER';
export const AUTHCORE_SET_FORCE_REAUTH = 'AUTHCORE_SET_FORCE_REAUTH';
export const ISCN_SET_TOTAL_FEE = 'ISCN_SET_TOTAL_FEE';

export const WALLET_SET_ADDRESS = 'WALLET_SET_ADDRESS';
export const WALLET_SET_SIGNER = 'WALLET_SET_SIGNER';
export const WALLET_SET_CONNECTOR = 'WALLET_SET_CONNECTOR';
export const WALLET_SET_METHOD_TYPE = 'WALLET_SET_METHOD_TYPE';
export const WALLET_SET_USER_INFO = 'WALLET_SET_USER_INFO';
export const WALLET_SET_IS_LOGGING_IN = 'WALLET_SET_IS_LOGGING_IN';
export const WALLET_SET_IS_CONNECTING_WALLET = 'WALLET_SET_IS_CONNECTING_WALLET';
